import {
  getSuggestedLocations,
  WMarketplaceCitiesStatesResponse,
} from '@zola-helpers/client/dist/es/api/marketplace';
import _debounce from 'lodash/debounce';

export const baseSuggestion = { name: 'My city is not listed', type: 'NOT_LISTED' };

// This has to be lifted out of the component, otherwise its not the same debounced function
export const debouncedFetchSuggestedLocations = _debounce(
  (value, setSuggestedLocations, includeBaseSuggestion = true) => {
    if (value.trim().length === 0) {
      setSuggestedLocations([]);
      return;
    }
    getSuggestedLocations(value)
      .then((response: WMarketplaceCitiesStatesResponse) => {
        const { entities } = response;
        // Only return city search results
        if (entities) {
          let filteredResponses = entities.filter(e => e.type !== 'US_STATE');
          if (includeBaseSuggestion) {
            filteredResponses = filteredResponses.concat([baseSuggestion]);
          }
          setSuggestedLocations(filteredResponses);
        }
      })
      .catch(() => {
        throw new Error('Suggestions not fetched');
      });
  },
  250
);

type CityStatePartial = { city: string; state_province: string };

// pre: given a cityState string as returned by marketplace universal search, ex. 'Denver, CO', or freeform text that must include a comma **
// post: returns object with city, state_province fields, using comma as delimiter
export const parseCityState = (cityStateStr?: string | null): CityStatePartial | undefined => {
  if (!cityStateStr) return undefined;
  const delimitedArr = cityStateStr.split(',');
  // trim leading and trailing whitespaces
  const arr = delimitedArr.map(k => k.trim());
  // use last comma as delimiter
  const stateCode = arr[arr.length - 1];
  if (stateCode === baseSuggestion.name) {
    return undefined;
  }
  const city = arr.splice(0, arr.length - 1).join(', ');
  return {
    city,
    state_province: stateCode,
  };
};
